// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"086be2ac","433":"88d91c90"}[chunkId] + ".chunk.css";
};